import Icon from '../../assets/images/Logo.svg';
export default function Helmet() {
    var faviconElement = document.createElement('link');
    faviconElement.rel = 'icon';
    faviconElement.href = Icon;
    document.head.appendChild(faviconElement);
}
